import AppVersion from "@/enum/AppVersion";

const AppVersionNameMap = {
    [AppVersion.FREE]: "免费版",
    [AppVersion.BASE]: "标准版",
    [AppVersion.PREMIUM]: "高级版",
    [AppVersion.GLORY]: "荣誉版",
    [AppVersion.GLORY_V1]: "荣誉版V1",
};

export default AppVersionNameMap;
